import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const Resources = MatxLoadable({
  loader: () => import("./Resources"),
});

const resourcesRoutes = [
  {
    path: "/resources",
    component: Resources,
    auth: authRoles.admin,
  },
];

export default resourcesRoutes;
